import { IDateService } from '../interface/date.interface';
import { BasicDateService } from './basic/basic.date.service';
import { DateFnsDateService } from './date-fns/date-fns.date.service';
import { MomentDateService } from './moment/moment.date.service';

export const STRATEGIES: {
    [key: string]: new (date: Date | string | number) => IDateService;
} = {
    basic: BasicDateService,
    'date-fns': DateFnsDateService,
    moment: MomentDateService
};
